export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div  className='col-xs-10'>
          <div className='section-title'>

            <h2>Serviciile noastre</h2>

            <p>
             La finalizarea examinarilor de medicina muncii, angajatul si angajatorul vor primi rezultatul evaluarii prin intermediul fisei de aptitudine in care se mentioneaza aptitudinea in munca conform profesiei/functiei.
            </p>
          </div>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-6 col-xs-10'>
                  {' '}
                  <i className={d.icon}></i>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
  
        </div>
      </div>
    </div>
  )
}
